<template>
  <v-dialog :value="value" persistent scrollable max-width="900px" @input="$emit('input', $event)">
    <v-card>
      <v-toolbar flat>
        <h2 class="font-weight-black primary--text mb-0">
          {{ $t('expenses.file') + ': ' + (fileId || '') }}
        </h2>
      </v-toolbar>
      <v-card-text class="text-center">
        <iframe
          v-if="isPdf && dataUrl"
          :src="dataUrl"
          frameborder="0"
          width="100%"
          height="400px"
        />
        <zoom-on-hover v-if="isImage && dataUrl" :img-normal="dataUrl" />
        <v-btn
          v-if="isCompressed && !loading"
          :loading="downloading"
          :disabled="downloading"
          color="primary"
          @click="$emit('download')"
        >
          volver a descargar
        </v-btn>
        <v-progress-circular
          v-if="!dataUrl && loading"
          color="primary"
          size="50"
          indeterminate
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error darken-1" round flat @click="close">
          {{ $t('general.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FILE_TYPE, isCompressedFile } from './request.model'

/**
 * Visor de archivos adjuntos (mismo diálogo que usa la vista de reservas).
 *
 * Es presentacional: recibe el contenido ya descargado en `dataUrl` y avisa por
 * eventos. PDF se muestra en iframe, imágenes con zoom y los comprimidos
 * (zip / rar) se descargan, dejando un botón para volver a bajarlos.
 */
export default {
  name: 'FileViewerDialog',
  props: {
    /** Visibilidad (v-model). */
    value: {
      type: Boolean,
      default: false
    },
    fileId: {
      type: [Number, String],
      default: null
    },
    fileTypeId: {
      type: [Number, String],
      default: null
    },
    /** Contenido en data URL (base64) tal como lo regresa api/File/{id}/get. */
    dataUrl: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    /** Descarga en curso del comprimido. */
    downloading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPdf () {
      return Number(this.fileTypeId) === FILE_TYPE.PDF
    },
    isCompressed () {
      return isCompressedFile(this.fileTypeId)
    },
    isImage () {
      return !this.isPdf && !this.isCompressed
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requests/FileViewerDialog.vue